import { SESSION } from 'store/types'

export const clearSingleSession = () => ({
  type: SESSION.CLEAR_SINGLE_SESSION,
})
